module.exports = __webpack_public_path__ + "static/img/seoul-120-pt.d948fa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/seoul-120-pt.jpg
// module id = UTeT
// module chunks = 0